import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  userInfoFullScreen : {
    [theme.fn.smallerThan('sm')]: {
      display: 'none',
    },
  },

  burger: {
    [theme.fn.largerThan('sm')]: {
      display: 'none',
    },
  },

}));